import React, { useEffect } from "react";
import { getStoredValue } from "./storagehelper";

const WindowEventsDemo = () => {
  const platform = navigator?.userAgentData?.platform || navigator?.platform || "unknown";

  const isDesktop = platform.toLowerCase().includes("win") || platform.toLowerCase().includes("mac") || platform.toLowerCase().includes("linux");

  const allowedKeys = [
    "cachedIP",
    "commonFacilityCode",
    "filter_menu_list",
    "inmateMessageCount",
    "isLoggedIn",
    "menu_list",
    "signalRId",
    "user",
  ];

  useEffect(() => {
    // 🔹 Common logout event listener (works on all devices)
    const handleStorageChange = (event) => {
      if (event.key === "logout-event") {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/facilityuser"; // redirect to login
      }
    };

    window.addEventListener("storage", handleStorageChange);

    if (isDesktop) {
      // 1️⃣ Copy localStorage → sessionStorage
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (allowedKeys.includes(key)) {
          const value = localStorage.getItem(key);
          sessionStorage.setItem(key, value);
        }
      }

      // 2️⃣ Copy sessionStorage → localStorage
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (allowedKeys.includes(key)) {
          const value = sessionStorage.getItem(key);
          localStorage.setItem(key, value);
        }
      }

      // 💻 Desktop behavior (beforeunload works reliably)
      const handleBeforeUnload = () => {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (allowedKeys.includes(key)) {
            const value = localStorage.getItem(key);
            sessionStorage.setItem(key, value);
          }
        }
        localStorage.clear();
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("storage", handleStorageChange);
      };
    } else {
      // 📱 Mobile behavior
      const clearLocalData = () => {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          const value = localStorage.getItem(key);
          sessionStorage.setItem(key, value);
        }
        localStorage.clear();
      };

      const handlePageHide = (event) => {
        if (!event.persisted) clearLocalData();
      };

      const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          // small delay to prevent false triggers
          setTimeout(() => clearLocalData(), 200);
        }
      };

      window.addEventListener("pagehide", handlePageHide);
      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        window.removeEventListener("pagehide", handlePageHide);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        window.removeEventListener("storage", handleStorageChange);
      };
    }
  }, [isDesktop]);

  return null;
};

export default WindowEventsDemo;
